import { render, staticRenderFns } from "./CookingClasses.vue?vue&type=template&id=5c9b663e&scoped=true"
import script from "./CookingClasses.vue?vue&type=script&lang=js"
export * from "./CookingClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9b663e",
  null
  
)

export default component.exports